import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { GameService } from '../../firebase/game.service';
import { withLatestFrom, map, catchError } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppState } from '../app.state';
import * as GameHistoryActions from './gameHistory.actions';
import * as GameActions  from '../game/game.actions';

@Injectable()
export class GameHistoryEffects {
    constructor(private actions$: Actions, private store$: Store<AppState>, private gameService: GameService) {}

    /*** READ IT FROM THE STORE ONLY SAVE TO LOCAL STORAGE WHEN GAME ENDS */

    
    gameOverAction$ = createEffect(() => this.actions$.pipe(
        ofType(GameActions.GameDispatcherActions.advancedToGameOver),
        withLatestFrom(this.store$),
        map(([action, storeState]) => {
            const gameState = JSON.parse(JSON.stringify(storeState.game.games[action.gameStateId].dealer));
            return GameHistoryActions.receiveGameSummary({
                summary: gameState.summary,
                gameStateId: action.gameStateId,
                events: gameState.events,
                tableId: storeState.game.games[action.gameStateId].table.id,
                handId: gameState.id
            });
        }),
        catchError((error, caught) => {
            const errorCode = error.code ? error.code : '';
            const message = error.message ? error.message : 'Error in gameOverAction$ effect.';
            console.error(`${errorCode}  -  ${message}`);
            return caught;
        }),
    ));
}
